<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/acsw_full-01.jpg')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Australian Canine Scent Work
        </h1>

        <p class="subheading font-weight-regular">
          To learn about ACSW and the sport of Canine Scent Work,
          <br>please visit the
          <a
            href="https://acsw.com.au"
            target="_blank"
          ><button>ACSW</button></a> web site
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',
  }
</script>
